import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-navy pb-20 px-6" data-id="element-219">
      <div className="max-w-3xl mx-auto" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-221">
          <h3 className="text-amber-500 font-bold tracking-wider text-sm uppercase mb-6" data-id="element-222">
            El Verdadero Problema
          </h3>

          <div className="space-y-6 text-lg text-slate-200 leading-relaxed" data-id="element-223">
            <p data-id="element-224">
              El problema no es el mensaje de tu ex. El problema es que le diste
              la{' '}
              <strong className="text-white font-bold bg-amber-900/40 px-1" data-id="element-225">
                "llave maestra" de tu tranquilidad
              </strong>{' '}
              las 24 horas del día. Cada vez que respondés desde la herida, cada
              vez que intentás "explicar" tu punto de vista o justificar por qué
              hiciste lo que hiciste, estás mordiendo el anzuelo.
            </p>

            <p data-id="element-226">
              Esa energía que gastás tipeando testamentos de odio es{' '}
              <strong className="text-white font-bold" data-id="element-227">
                energía que le robás a tus hijos
              </strong>
              . Ellos te necesitan presente, no con los ojos inyectados en
              sangre mirando una pantalla mientras ellos juegan solos.
            </p>

            <div className="my-10 flex justify-center" data-id="element-228">
              <img src="https://cdn.magicpatterns.com/uploads/mcxGcQATxirksxMtkApPg2/Diseno_sin_titulo_(1).png" alt="Padres estresados mirando sus celulares por mensajes conflictivos" className="w-full md:w-full rounded-2xl shadow-2xl shadow-black/40 border border-slate-700/50" data-id="element-229" />
            </div>

            <div className="bg-slate-800/50 p-6 rounded-xl border border-slate-700 mt-8" data-id="element-230">
              <p className="text-xl font-playfair font-bold text-white text-center" data-id="element-231">
                El conflicto se alimenta de tu reacción. Si no hay reacción, el
                fuego se apaga.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}